<template>
  <div class="card">
    <div
      class="card-header has-padding-2 has-padding-left-10 has-background-primary is-size-5 has-text-weight-bold"
    >
      <div class="card-header-title has-text-white">New Shipping Request</div>
    </div>

    <div class="card-content">
      <article class="message is-dark">
        <div class="message-body is-size-6">
          You are about to initiate a Dangerous Goods (DG) Shipping Application to the
          Nigerian Maritime Administration and Safety Agency (NIMASA).
          <ol class="has-margin-top-5 info-list">
            <li>
              A DG Shipping Application is valid for a single shipment only
.  If there is more than one vessel, each vessel shall have
              its own shipping application request and consequent approval.
            </li>
            <li>Each shipping application can be saved and completed at a later time.</li>
            <li>You will be logged out automatically after 5 minutes of inactivity.</li>
            <li>
              Every detail filled on the shipping application is legally binding.
               Ensure you fill this to the best of your knowledge and in
              conformity with the stipulated IMDG Code.
            </li>
            <li>
              The shipment expected date of arrival must be a future date, the application can not be made after the Dangerous Good shipment have arrived.
            </li>
          </ol>
        </div>
      </article>

      <div class="is-flex justify-center has-margin-top-15 has-margin-bottom-10">
        <button
          class="button is-primary is-medium "
          @click="onInitiateShippingRequest"

        >Initiate Shipping Application</button>
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="false"></b-loading>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmCard from "./ConfirmShippingRequestInitiationCard";
import InitiateShippingRequestMutation from "@/modules/shippersModule/api/graphql/mutations/InitiateShippingRequest";

import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("shippers");
import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";

export default {
  name: "InitiateShippingRequest",

  components: {
    ConfirmCard
  },

  data() {
    return {
      loading: false,
      confirm: false
    };
  },

  methods: {
    ...mapMutations({
      commitFormDetails: SHIPPER_MUTATION_TYPES.UPDATE_FORM_DETAILS,
      updateShippingRequest:
        SHIPPER_MUTATION_TYPES.UPDATE_SHIPPING_REQUEST_WITH_DATA_FROM_API
    }),

    /**
     * Initiate a shipping request, and store its ID and reference_number in the store
     */
    initiateShippingRequest: function() {
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: InitiateShippingRequestMutation
        })
        .then(response => {
          const data = response.data.InitiateShippingRequest;
          this.commitFormDetails(data);

          this.$toast.open({
            duration: 3000,
            message: "A new shipping request has been initialized",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            message:
              "An error occured while trying to initialize a new shipping request",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onInitiateShippingRequest: function() {
      this.$modal.open({
        parent: this,
        component: ConfirmCard,
        hasModalCard: true,
        props: {
          initiateShippingRequest: this.initiateShippingRequest
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.info-list li {
  margin: 13px 10px;
}
</style>
